import { pede } from './api';
import { elements, parseJsx } from '../code/parse';

export const REVIEW_ATIVO = false;

export interface Achado {
	severidade: 'alta' | 'media' | 'baixa';
	onde: string;
	problema: string;
	correcao: string;
	/** pedaço literal do código, é o que liga o achado ao elemento */
	trecho?: string;
	/** o que entra no lugar do trecho — é o que torna a correção aplicável sozinha */
	substituto?: string;
	/** marcado quando a correção já foi aplicada no código */
	aplicado?: boolean;
}

export async function reviewAnimations(code: string, endpoint = '/api/review'): Promise<Achado[]> {
	const data = await pede<{ achados?: Achado[] }>(endpoint, { code });
	return data.achados ?? [];
}

export function aplicaAchado(src: string, achado: Achado): string | null {
	const alvo = achado.trecho?.trim();
	const novo = achado.substituto?.trim();
	if (!alvo || !novo || alvo === novo) return null;

	const idx = src.indexOf(alvo);
	if (idx < 0) return null;
	// aparece mais de uma vez: trocar a errada seria pior que não trocar
	if (src.indexOf(alvo, idx + 1) >= 0) return null;

	const next = src.slice(0, idx) + novo + src.slice(idx + alvo.length);
	try {
		parseJsx(next);
	} catch {
		return null;
	}
	return next;
}

export function aplicaAltas(src: string, achados: Achado[]): { source: string; achados: Achado[] } {
	let source = src;

	const marcados = achados.map((achado) => {
		if (achado.severidade !== 'alta') return achado;
		const next = aplicaAchado(source, achado);
		if (!next) return achado;
		source = next;
		return { ...achado, aplicado: true };
	});

	return { source, achados: marcados };
}

export function locDoAchado(source: string, achado: Achado): string | null {
	if (!achado.trecho) return null;

	const idx = source.indexOf(achado.trecho.trim());
	if (idx < 0) return null;

	try {
		// o último elemento que ABRE antes do trecho é o dono dele
		const dono = elements(source).filter((e) => e.start <= idx).pop();
		return dono?.loc ?? null;
	} catch {
		return null;
	}
}
